import { Capacitor } from "@capacitor/core";
import { AppUpdate, AppUpdateAvailability } from "@capawesome/capacitor-app-update";
import { useQuery } from "@tanstack/react-query";

export function useFlexibleAppUpdate() {
  return useQuery({
    queryKey: ["app-flexible-update"],
    staleTime: Infinity,
    queryFn: async () => {
      if (Capacitor.getPlatform() !== "android") {
        return null;
      }

      const result = await AppUpdate.getAppUpdateInfo();

      if (result.updateAvailability !== AppUpdateAvailability.UPDATE_AVAILABLE) {
        return;
      }

      if (result.flexibleUpdateAllowed === true) {
        await AppUpdate.startFlexibleUpdate();
      }

      return result;
    },
  });
}
